var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7063 22.9028L25.1487 3.11862C25.283 2.34661 24.5175 1.72708 23.7905 2.01937L1.988 10.7843C1.2005 11.1009 1.1406 12.1927 1.88875 12.5936L7.68135 15.697C7.93636 15.8336 8.1197 16.074 8.18405 16.3561L9.34148 21.4297C9.50623 22.1518 10.3716 22.4505 10.9467 21.9837L13.9209 19.5693C14.2865 19.2725 14.8096 19.271 15.1769 19.5657L20.0954 23.5114C20.689 23.9876 21.5759 23.6525 21.7063 22.9028Z",
    stroke: "#5956E9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8631 7.27445L6.8664 14.3686C6.67804 14.4901 6.59357 14.7222 6.65972 14.9363L8.85409 22.0413C8.91881 22.2509 9.11252 22.3938 9.33182 22.3938H9.39106C9.65827 22.3938 9.87826 22.1837 9.89053 21.9167L10.1611 16.0286C10.1671 15.8982 10.2238 15.7754 10.3191 15.6863L18.4756 8.05982C18.9209 7.64351 18.3753 6.94401 17.8631 7.27445Z",
    fill: "#5956E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon (1).c65797f972c3ad9c5e2df3c93aa97f4b.svg";
export { ForwardRef as ReactComponent };